// import './index' // Décommenter pour utiliser React
import KrealabModal from "./elements/KrealabModal";
import KrealabAjaxForm from './elements/KrealabAjaxForm';
import './vendor'
import './components'
import './elements'
import './admin'

new KrealabModal();

jQuery(function($){
    new KrealabAjaxForm($);
});